import type { ExpenseCategory, ExpenseSubcategory } from '../types/expenses';
import { EXPENSE_SUBCATEGORY_SUGGESTIONS } from './expenseActions';
import { userDisplayNameOr, type NameableUser } from './userDisplayName';

// Helpers del formulario de gasto compartidos entre la página de Gastos y el asistente (FI-22).

// NameableUser y no un Pick estricto: hay pantallas que traen al empleado con solo fullName y
// username (ExpenseCaptureModal), y exigirles firstName/lastName solo para nombrarlo seria
// obligarlas a pedir campos que no usan.
export function displayEmployeeName(user: NameableUser): string {
  return userDisplayNameOr(user);
}

/** Sugerencias fijas + subcategorías guardadas, sin duplicados (ignora mayúsculas). */
export function mergedSubcategoryNames(category: ExpenseCategory, fetched: ExpenseSubcategory[] | undefined): string[] {
  const suggestions = EXPENSE_SUBCATEGORY_SUGGESTIONS[category] ?? [];
  const fromDb = (fetched ?? []).map((item) => item.name);
  const seen = new Set<string>();
  const merged: string[] = [];
  for (const name of [...suggestions, ...fromDb]) {
    const key = name.toLowerCase();
    if (seen.has(key)) continue;
    seen.add(key);
    merged.push(name);
  }
  return merged;
}
